import React from 'react'

import { Button, ModalBox } from '@fourthwall/components'

type Props = {
  onCreateClick(): void
  close(): void
}

export const EmptyModal = ({ onCreateClick, close }: Props) => {
  return (
    <ModalBox
      title="You don’t have any video series created"
      buttons={[
        <Button
          label="Create video series"
          onClick={() => {
            close()
            onCreateClick()
          }}
        />,
        <Button label="Close" appearance="primary" onClick={close} />,
      ]}
      size="small"
      onClose={close}
    />
  )
}
